<template>
  <div class="product_analysis_contaner">
    <div class="query_container">
      <el-form :model="formInline" style="display: flex;
    flex-wrap: nowrap;">
        <el-form-item label="指标名称" style="width: 300px;">
          <el-col :span="18">
            <el-select
              v-model="formInline.type"
              size="small"
              placeholder="指标名称"
              @change="changeType"
            >
              <el-option label="面积" value="面积"></el-option>
              <el-option label="产量" value="产量"></el-option>
              <el-option label="产值" value="产值"></el-option>
              <el-option label="育苗面积" value="育苗面积"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="时间">
          <el-row>
            <el-col :span="10">
              <el-date-picker
                v-model="formInline.queryStartTime"
                type="year"
                placeholder="选择年"
                size="small"
                value-format="yyyy"
              ></el-date-picker>
            </el-col>
            <el-col :span="1">
              <p style="text-align:center">~</p>
            </el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="formInline.queryEndTime"
                type="year"
                value-format="yyyy"
                size="small"
                placeholder="选择年"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <div class="issue" @click="onSubmit">搜索</div>
          <div class="issue" @click="tableChange">图表转换</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="section-list w1300 marginAuto" v-show="!echartsShow">
      <el-table
        :data="marketPriceList"
        border
        style="width: 100%"
        :header-cell-style="{background:'#6baf6f',color:'#fff'}"
      >
        <el-table-column prop="dataYear" label="日期" align="center"></el-table-column>
        <el-table-column prop="type" label="指标名称" align="center">
          <template>{{formInline.type}}</template>
        </el-table-column>
        <el-table-column prop="value" label="数值" align="center"></el-table-column>
        <el-table-column prop="stateName" label="单位" align="center">
          <template>{{formInline.type == '面积'?'亩':(formInline.type == '产值'?'万元':(formInline.type == '产量'?'吨':'亩'))}}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="tab_pagination"
        background
        :pageSize="pageSize"
        layout="prev, pager, next"
        @current-change="currentChange"
        :total="total"
      ></el-pagination>
    </div>
    <div class="section-list w1300 marginAuto" v-show="echartsShow">
      <div class="echarts" id="dataEcharts" style="width: 100%;height:600px"></div>
    </div>
  </div>
</template>

<script>
import echarts from "../../utils/js/echartsServer";
import {
  getTeaPlantingAreaOverTheYear,
  getTeaPlantingProcessingYieldOverTheYear,
  teaProductionEcharts,
  teaSeedingPlantingArea
} from "../../utils/api/productAnalysis";
export default {
  name: "ProductAnalysis",
  data() {
    return {
      formInline: {
        user: "",
        type: "面积",
        queryStartTime: "",
        queryEndTime: ""
      },
      marketPriceList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentType: "面积",
      echartsShow: false
    };
  },
  mounted() {
    this.changeData();
  },
  methods: {
    // 图标转换
    tableChange() {
      this.echartsShow = !this.echartsShow;
      this.changeData();
    },
    onSubmit() {
      this.filterCheck();
    },
    currentChange(value) {
      this.currentPage = value;
      this.changeData();
    },
    changeType(value) {
      this.currentType = value;
    },
    // 切换
    changeData() {
      let dataYear = [];
      if (this.formInline.queryStartTime && this.formInline.queryEndTime) {
        dataYear = [
          this.formInline.queryStartTime,
          this.formInline.queryEndTime
        ];
      } else {
        dataYear = [];
      }
      if (this.formInline.type == "面积") {
        this.teaAreaEcharts(dataYear,); //历年茶叶种植面积
      } else if (this.formInline.type == "产量") {
        this.teaYieldEcharts(dataYear,);
      } else if (this.formInline.type == "产值") {
        //历年茶叶种植产量
        this.teaProductionEcharts(dataYear,);
      } else if (this.formInline.type == "育苗面积") {
        this.teaSeedingPlantingArea(dataYear,);
      }
    },
    // 搜索条件
    filterCheck() {
      if (
        (this.formInline.queryStartTime && !this.formInline.queryEndTime) ||
        (!this.formInline.queryStartTime && this.formInline.queryEndTime)
      ) {
        this.$message({
          message: "搜索数据请选择时间区间",
          type: "warning"
        });
        return;
      }
      this.changeData();
    },
    //福安历年茶园种植面积
    async teaAreaEcharts(dataYear) {
      let res = await getTeaPlantingAreaOverTheYear({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        bq: { dataYear },
        township:'全市',
        orderBy: {
          dataYear: "desc"
        },
      });
      if (!this.echartsShow ) {
        this.marketPriceList = JSON.parse(
          JSON.stringify(res.data.data.records).replace(/area/g, "value")
        );
        this.total = res.data.data.total;
        this.formInline.type = this.currentType;
      } else {
        // 图表
        let yList = [];
        let xList = [];
        res.data.data.records.forEach(item => {
          xList.push(item.dataYear);
          yList.push(item.area);
        });

        let paramsData = {
          yList,
          xList,
          unit: "亩",
          name: "面积",
          inverse: true,
        };
        echarts.ProductAnalysisChart("dataEcharts", paramsData);
      }
    },
    //加工产量
    async teaYieldEcharts(dataYear) {
      let that = this;
      let res = await getTeaPlantingProcessingYieldOverTheYear({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        startYear: dataYear[0],
        endYear: dataYear[1],
      });
      if (!this.echartsShow ) {
        this.marketPriceList = JSON.parse(
          JSON.stringify(res.data.data.records).replace(
            /processingYield/g,
            "value"
          )
        );
        this.total = res.data.data.total;
        this.formInline.type = this.currentType;
      } else {
        // 图表
        let yList = [];
        let xList = [];
        res.data.data.forEach(item => {
          xList.push(item.dataYear);
          yList.push(item.processingYield);
        });

        let paramsData = {
          yList,
          xList,
          unit: "吨",
          name: "产量",
          inverse: true,
        };
        echarts.ProductAnalysisChart("dataEcharts", paramsData);
      }
    },
    //加工产值
    async teaProductionEcharts(dataYear) {
      let that = this;
      let res = await teaProductionEcharts({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        startYear: dataYear[0],
        endYear: dataYear[1],
      });
      if (!this.echartsShow ) {
        this.marketPriceList = JSON.parse(
          JSON.stringify(res.data.data.records).replace(/output/g, "value")
        );
        this.total = res.data.data.total;
        this.formInline.type = this.currentType;
      } else {
        // 图表
        let yList = [];
        let xList = [];
        res.data.data.forEach(item => {
          xList.push(item.dataYear);
          yList.push(item.output);
        });

        let paramsData = {
          yList,
          xList,
          unit: "万元",
          name: "产值",
          inverse: true,
        };
        echarts.ProductAnalysisChart("dataEcharts", paramsData);
      }
    },
    //育苗面积
    async teaSeedingPlantingArea(dataYear) {
      let that = this;
      let res = await teaSeedingPlantingArea({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        bq: { dataYear },
        orderBy: {
          dataYear: "desc"
        },
      });
      if (!this.echartsShow ) {
        this.marketPriceList = JSON.parse(
          JSON.stringify(res.data.data.records).replace(/area/g, "value")
        );
        this.total = res.data.data.total;
        this.formInline.type = this.currentType;
      } else {
        // 图表
        let yList = [];
        let xList = [];
        res.data.data.records.forEach(item => {
          xList.push(item.dataYear);
          yList.push(item.area);
        });

        let paramsData = {
          yList,
          xList,
          unit: "亩",
          name: "面积",
          inverse: true,
        };
        echarts.ProductAnalysisChart("dataEcharts", paramsData);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin baseBlockSet($display:block,$w:inherit,$h:inherit,$lineHeight:inherit,$texteAlign:none,$fontSize:inherit,$color:inherit,$fontFamily:inherit,$fontWeight:inherit,$cursor:auto,$backgroundColor:none){
  display: $display;
  width: $w;
  height: $h;
  line-height: $lineHeight;
  font-size: $fontSize;
  font-weight: $fontWeight;
  font-family: $fontFamily;
  text-align: $texteAlign;
  color: $color;
  background-color: $backgroundColor;
  cursor:$cursor
}
.product_analysis_contaner {
  margin-left: 30px;
  width: calc(100% - 200px);
  .section-list {
    width: 100%;
  }
  .issue {
    @include  baseBlockSet($display:inline-block,$texteAlign:center,$fontSize:14px,$color:#fff,$fontFamily:PingFangSC,$fontWeight:400,$cursor:pointer);
    background: linear-gradient(90deg, #1cba4d, #a1dc61);
    border-radius: 8px;
    margin-left: 20px;
    padding: 0px 10px;
  }
}
</style>
